import cx from 'classnames';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../../core/Tracking/Amplitude/Amplitude';
import { Destination } from '../../../../resources/destination/domain/types/destination';
import { DestinationArticle } from '../../../../resources/destinationArticles/domain/types/destinationArticle';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { Typography } from '../../typography/Typography';

import style from './DestinationArticleTag.module.css';

type Size = 'small' | 'medium';

export function DestinationArticleTag({
    size,
    articleType,
    destination,
}: {
    size: Size;
    articleType: DestinationArticle['type'];
    destination: PickDomain<Destination, 'id' | 'slug'>;
}) {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();

    const scaleMapping = {
        small: 'primary-xxs-bold' as const,
        medium: 'primary-xs-bold' as const,
    };

    return (
        <Typography
            className={cx(style.tag, {
                [style.inspiration]: articleType === 'general_inspiration',
                [style.practicalInformation]: articleType !== 'general_inspiration',
                [style.small]: size === 'small',
                [style.medium]: size === 'medium',
            })}
            as="span"
            scale={scaleMapping[size]}
            onClick={() => {
                trackEvent((ampli, defaultProperties) => {
                    ampli.articleTagClicked({
                        ...defaultProperties,
                        destination_id: destination.id,
                        destination_slug: destination.slug,
                        article_type: articleType,
                    });
                });
            }}
        >
            {formatMessage(
                { id: 'global.destinationArticle.type' },
                {
                    type: articleType,
                },
            )}
        </Typography>
    );
}
